module.exports = __webpack_public_path__ + "media/images/pages/fcr-case/case-3-a746242c3192fda204a0d5495df260d1.png";